export default __webpack_public_path__ + "static/media/Mark-4-HUD-01.b3e396f7.jpg";